<template>
	<div class="centerWidth">
		<div class="gaokao">
			<div class="gaokao-nav">
				<span @click="goMyCenter">个人中心 > </span>
				<span>学业心理调节测评</span>
			</div>
			<section class="gaokao-content">
				<div class="my-title">学业心理调节测评</div>
				<div class="gaokao-con">
					<p>
						根据《国务院关于深化考试招生制度改革的实施意见》(国发 [2014] 35号)要求,全面深化统一高考招生改革(简称“高考改革新方案”) 2017年起将 在全国各地整体逐步实施，2014年已在上海、浙江率先试点。全国各地高中生将自主确定选考科目，各招生高校根据本校各专业选考科目，结合统-高考和高中学业水平考试成绩，综合评价，择优录取。
					</p>
					<p>
						新高考，- -些学生和家长感到了迷惘和困惑，特别是不知道该如何选择选考科目。实际上，考生能否有效地自主选择考试科目取决于自身的自我认识能力，具体而言考生对于自己的职业倾向是否有明确、准确的认识，是否了解自己的兴趣、特长。选考科目要结合职业规划来综合考虑，要选感兴趣的和选能考好的。调查研究表明，学生的学科成绩与对本学科的兴趣呈正相关的关系。学科兴趣是学业成就的重要预测指标之一。虽说「兴趣是最好的老师」，但是对于性格志趣正在发展的学生来说，究竟如何确立真正的学科兴趣成了广大考生和家长亟需解决的问题。
					</p>
					<p>
						为帮助考生科学合理的选择选考科目，专家团队研发出“新高考选科测评”，供全国各地参加新高考的高-新生及其家长使用。从学业状态和生涯发展两个方面对考生进行综合评估。通过全方位的科学分析，为考生匹配最适合的选考科目，做好升学规划!
					</p>
				</div>
				<div class="gaokao-notice">
					<p class="gk-notice-tit">考前须知</p>
					<ul class="gk-notice-li">
						<li>1、请务必诚实、独立地回答问题，只有如此，才能得到有效的结果。</li>
						<li>2、每一题目请以第一印象作答，不必仔细推敲，答案没有好坏、对错之分，根据自己的实际情况做答。</li>
						<li>3、本报告给广大考生和家长提供了-种科学的方法，-份可靠的依据，从而让考生和家长能了解和接触更多的可能，而并非限制学生的选择。</li>
						<li>4、所有测评结果的得分仅代表学生本人各种指标之间的相对水平，而不代表考生的这些指标在人群总体中的绝对水平。</li>
						<li>6、只要你是认真、真实地填写了测试问卷,那么通常情况下你都能得到确实和你相匹配的结果。希望你能从中或多或少地获得一些有益的信息。</li>
					</ul>
				</div>
				<button class="gaokao-btn" @click="goTest()">开始测试</button>
			</section>

		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {

		};
	},
	methods: {
		// 个人中心
		goMyCenter() {
			this.$router.push('/myIndex');
		},
		// 测试
		goTest() {
			this.$router.push('/mindtest');
		}
	}
};
</script>

<style scoped>
.gaokao {
	width: 100%;
	height: auto;
	overflow: hidden;
}
.gaokao-nav{
	width: 100%;
	display: flex;
	align-items: center;
	padding: 20px 0;
}
.gaokao-nav span{
	font-size: 15px;
	color: #333;
}
.gaokao-nav span:last-child{
	color: #333;
}
/* gaokao-content */
.gaokao-content{
	padding: 0 20px;
	width: 100%;
	height: auto;
	overflow: hidden;
	background-color: #fff;
	margin-bottom: 25px;
}
.gaokao-con{
	padding: 50px 20px;
	height: auto;
	overflow: hidden;
}
.gaokao-con p{
	font-size: 14px;
	color: #333;
	text-indent: 2em;
	line-height: 28px;
}
/* gaokao-notice */
.gaokao-notice{
	width: 100%;
	padding: 0 40px 40px 40px;
	height: auto;
	overflow: hidden;
	background-color: #eee;
}
.gk-notice-tit{
	font-size: 17px;
	color: #333;
	padding: 40px 0;
}
.gk-notice-li{
	width: 100%;
	height: auto;
	overflow: hidden;
}
.gk-notice-li li{
	font-size: 15px;
	color: #333;
	padding-bottom: 15px;
}
.gk-notice-li li:last-child{
	padding-bottom: 0px;
}
.gaokao-btn{
	width: 200px;
	height: 40px;
	background-color: #333;
	border-radius: 6px;
	font-size: 16px;
	color: #fff;
	line-height: 40px;
	margin: 50px auto;
	display: block;
}
</style>
